<template>
  <b-overlay  :show="Esperar">
    <div class="px-3">

    
    <b-modal v-model="ver" no-close-on-backdrop no-close-on-esc>
      <template #modal-header>
        <h5>Actualizar Producto</h5>
      </template>
      <b-form-group label="Nombre Producto" label-for="name-input">
        <b-form-input id="name-input" autofocus :formatter="quitarAcentos" v-model="selProducto.Nombre"></b-form-input>
      </b-form-group>

      <template #modal-footer>
        <b-button @click="onEliminar" class="ml-0 mr-auto" variant="danger"> <b-icon-trash /> Eliminar</b-button>
        <b-button @click="ver = false">Cerrar</b-button>
        <b-button @click="onUpdate" variant="success">Actualizar</b-button>
      </template>
    </b-modal>

    <b-card>
      <template #header>
        <h5>Producto ({{ `${MisProductos.length} /  ${Productos.length}` }})</h5>
      </template>
      <b-table @row-clicked="onRowClick" :per-page="8" id="my-table" :current-page="actual" striped bordered small :items="MisProductos" :fields="['Nombre', 'Frio','Salud']">
        <template #cell(Frio)="row">
          <b-checkbox @change="UpdateFrio(row.item)" v-model="row.item.Frio" />
        </template>
        <template #cell(Salud)="row">
          <b-checkbox @change="UpdateSalud(row.item)" v-model="row.item.Salud" />
        </template>
      </b-table>
      <b-pagination v-model="actual" :total-rows="total" :per-page="8" aria-controls="my-table"></b-pagination>
    </b-card>

    <b-row>
      <b-col>
        <b-input-group class="my-2" prepend="Producto:">
          <b-input v-model="Nombre" placeholder="Producto nuevo"></b-input>
          <b-button @click="onGuardar" variant="success">Agregar</b-button>
        </b-input-group>
      </b-col>
    </b-row>
    </div>
  </b-overlay>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();

export default {
  computed: {
    total() {
      return this.MisProductos.length;
    },
    MisProductos() {
      let txt = this.Nombre;
      let rs = this.Productos.filter((x) => new RegExp(txt, "i").test(x.Nombre)).map((prod) => {
        return {
          Nombre: prod.Nombre,
          Frio: prod.Frio || false,
          Salud:prod.Salud || false,
          id: prod.id,
        };
      });

      return rs;
    },
    filas() {
      return this.Productos.length;
    },
  },
  methods: {
        UpdateSalud(dato) {
      this.Esperar = true;

      db.collection("Producto")
        .doc(dato.id)
        .update({ Salud: dato.Salud })
        .then(() => {
          this.Esperar = false;
        });
    },
    UpdateFrio(dato) {
      this.Esperar = true;

      db.collection("Producto")
        .doc(dato.id)
        .update({ Frio: dato.Frio })
        .then(() => {
          this.Esperar = false;
        });
    },
    quitarAcentos(cadena) {
      const acentos = { á: "a", é: "e", í: "i", ó: "o", ú: "u", Á: "A", É: "E", Í: "I", Ó: "O", Ú: "U", };
      let rs = cadena
        .split("")
        .map((letra) => acentos[letra] || letra)
        .join("")
        .toString();

      return rs;
    },
    onEliminar() {
      let d = this.selProducto;

      db.collection("Producto")
        .doc(d.id)
        .delete()
        .then(() => {
          this.ver = false;
        });
    },
    onRowClick(d) {
      this.selProducto = { Nombre: d.Nombre, id: d.id };
      this.ver = true;
    },
    Limpiar() {
      this.Nombre = "";
    },
    onUpdate() {
      let self = this;
      let d = this.selProducto;

      db.collection("Producto")
        .doc(d.id)
        .update({ Nombre: d.Nombre })
        .then(() => (self.ver = false));
    },
    onGuardar() {
      let self = this;
      db.collection("Producto")
        .add({ Nombre: this.Nombre })
        .then(() => (self.ver = false));
    },
  },
  data() {
    return {
      Esperar: false,
      ver: false,
      Nombre: "",
      Productos: null,
      actual: 1,
      selProducto: {},
    };
  },
  firestore: {
    Productos: db.collection("Producto").orderBy("Nombre"),
  },
};
</script>
